import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function EditIconSVG() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 39 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_25234_185957)">
        <path
          d="M26.651 25.4103H6.0592V9.98702H13.987V2.0592H26.651V4.08951L28.7102 2.11272V0H13.987L6.0592 7.92782L4 9.98702V27.4695H28.7102V15.345L26.651 17.4907V25.4103Z"
          fill="currentColor"
        />
        <path
          d="M34.7955 5.42619L31.6879 2.31863C31.4142 2.04483 30.9703 2.04483 30.6967 2.31863L17.5764 14.9191C17.495 15.0005 17.435 15.1007 17.4015 15.2107L15.8146 20.4248C15.6513 20.9613 16.1528 21.4628 16.6893 21.2995L22.0711 19.6616L34.7955 6.41753C35.0692 6.14379 35.0692 5.69992 34.7955 5.42619ZM18.7734 19.3852L17.7516 18.2683L18.4599 15.9405L20.2241 16.8897L21.1736 18.6543L18.7734 19.3852ZM32.8233 4.92989L21.645 16.1792L20.935 15.4691L32.1848 4.29027L32.8234 4.9288C32.8233 4.92928 32.8233 4.92953 32.8233 4.92989Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_25234_185957"
          x="0"
          y="0"
          width="39"
          height="35.4688"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_25234_185957"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_25234_185957"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default function EditIcon(
  props: Partial<CustomIconComponentProps> & { shadow?: boolean }
) {
  const { shadow, ...rest } = props

  return <Icon component={EditIconSVG} {...rest} />
}

EditIcon.defaultProps = {
  shadow: undefined
}
